import TitleBar from '../TitleBar/TitleBar'

const PageNotFound = () => {
  return (
    <>
            <TitleBar title="Page not found" />
        </>
  )
}

export default PageNotFound